import classes from './deleteEmail.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
const DeleteText = (props) => {
  let strings = getLocalizedStrings('NotificationSettings');

  let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  

 return(
    <div>
       <div className={classes.deleteDataRow}>
      <span className={classes.emailData}>{props.phoneNo}</span>
        <span className={classes.mobileButtonAlign}>
          <div className={classes.buttonAlign}>
            <span className={classes.removeButtonAlign}>
            <button className={classes.RemoveButton} onClick={(e,sn) =>props.deleteButtonHandler(e,props.text)}>{strings.deleteButtonValue}</button>
          </span>
          <span className={classes.EditButtonAlign}>
            <button className={classes.CancelButton} onClick={props.removeCancelHandler}>{strings.CancelButtonValue}</button>
          </span>
        </div>
        <div>
        {props.textData.textPrefErr ?
          <div className={classes.errorBox}> 
            <span><img className={classes.warningImg} src={warningIcon} alt="Warning Icon" /></span>
            <span className={classes.emailError}>{strings.deleteErrMsg}&nbsp;
              {props.textData.preferenceError.join(', ')}{strings.deleteErrMsg2}
              {props.textData.preferenceError.join(', ')}{strings.deleteErrMsg3}</span>
          </div> : null           
        }
        {props.textData.modifyTextError ? <span className={classes.errorBox}>{strings.errorMsg}</span> : null}
      </div>
 
      </span>
      </div>
    </div>
  );
};
export default DeleteText;